export default __webpack_public_path__ + "static/media/AE12.72e3cfab.jpg";